export default "__VITE_ASSET__DMOZ2GGE__"